import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from 'src/app/services/utils.service';
@Component({
  selector: 'app-no-lines-modal',
  templateUrl: './no-lines-modal.component.html',
  styleUrls: ['./no-lines-modal.component.scss']
})
export class NoLinesModalComponent implements OnInit {
  authoringContentData:any;
  isDialPad: boolean;
  clickFlow: number;

  constructor( private modalService:NgbModal, public utilsSvc: UtilsService,) { }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();  
  }
  onClickClose(){
    this.modalService.dismissAll();
  }

}
